import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { cryptoAddressAPI } from '../../utils/api';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Wallet } from 'lucide-react';

const CryptoAddresses = () => {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAddresses();
  }, []);

  const fetchAddresses = async () => {
    try {
      const response = await cryptoAddressAPI.getAll();
      setAddresses(response.data);
    } catch (error) {
      toast.error('Failed to load addresses');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="flex items-center justify-center min-h-[60vh]"><div className="loading-spinner"></div></div>;

  return (
    <div className="space-y-8 animate-fadeIn">
      <div>
        <h1 className="text-4xl font-bold text-black mb-2">Crypto Addresses</h1>
        <p className="text-gray-600">Manage your saved withdrawal addresses</p>
      </div>

      <Card className="p-6">
        <div className="flex items-center justify-center py-12">
          <div className="text-center">
            <Wallet className="w-12 h-12 text-gray-600 mx-auto mb-4" />
            <p className="text-gray-500">No saved addresses yet</p>
            <Button className="mt-4 text-white hover:opacity-90" style={{ background: '#062136' }}>Add Address</Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default CryptoAddresses;